<template>
	<div>
		<router-view></router-view>
		<loading></loading>
	</div>
</template>

<script>
// import axios from 'axios';
import moment from "moment";
import ApiService from "./utils/apiService";
import { setCatchErrorAPI } from "./utils/helpers";
import { TokenService } from "./utils/storageService";
import { EventBus } from "./main";

const Loading = () =>
	import(
		/* webpackChunkName: "app-loading" */ "./components/commons/Loading"
	);

export default {
	components: {
		Loading,
	},
	name: "Trackme",
	methods: {
		checkDatime() {
			let ts = moment(TokenService.getDatetime());
			let tc = moment();
			console.log("[ACT] CHECK at", tc.format("LLL"));

			let diff = moment(tc.format("YYYY-MM-DD HH:mm")).diff(
				ts.format("YYYY-MM-DD HH:mm"),
				"minutes"
			);
			if (diff >= Number(process.env.TOKEN_REFRESH) && diff < 60) {
				this.refreshToken();
			}
		},
		refreshToken() {
			console.log("[API] REFRESH TOKEN");
			ApiService.setHeader("token", TokenService.getToken());
			ApiService.post("/users/refreshtoken", {
				user: TokenService.getUser(),
			})
				.then((response) => {
					if (response.status == 201) {
						let r = response.data.data;

						if (r.days2pay < 0) {
							EventBus.$emit("tokenExpired", { expired: true });
						}

						TokenService.setToken(r.access_token);
						TokenService.setDatetime(
							moment().format("YYYY-MM-DD HH:mm")
						);
					}
				})
				.catch((error) => {
					setCatchErrorAPI("TOKEN:refresh", error);
				});
		},
		setLang() {
			let lang = TokenService.getLang();

			if (lang) {
				this.$i18n.locale = lang.toLowerCase();

				let wrap = document.getElementById("app-wrapper");
				wrap.setAttribute("lang", lang.toLowerCase());
			}
		},
		logout() {
			console.warn("[APP]: LOGOUT");
			TokenService.removeStorage();

			this.$router.push("/");
			EventBus.$emit("loadingClose");
		},
		async postUrl(currentUrl) {
			try {
				ApiService.setHeader("token", TokenService.getToken());
				const token = TokenService.getToken();
				const response = await ApiService.get(
					`/user-module/getAddUserMod?token=` +
						TokenService.getToken() +
						`&modulo=` +
						currentUrl +
						``,
					currentUrl
				);
				if (response.status === 200) {
				}
			} catch (error) {
				setCatchErrorAPI("getDaily:load", error);
			}
		},
		async sendUrl(currentUrl) {
			await this.postUrl(currentUrl);
		},
	},
	data() {
		return {
			//
		};
	},
	beforeMount() {
		this.setLang();
	},
	mounted() {
		let ms = Number(process.env.TOKEN_CHECK) * 60000;

		setInterval(() => {
			this.checkDatime();
		}, ms);

		EventBus.$on("logout", () => this.logout());

		EventBus.$once("tokenExpired", (expired) => {
			this.$toast.error(
				this.$i18n.t(`access.expired.message`),
				this.$i18n.t(`access.expired.title`),
				{ layout: 2, position: "topCenter" }
			);
			this.logout();
		});

		// this.$router.afterEach((to, from) => {
		// 	if (to.path !== from.path) {
		// 		let currentUrl = window.location.href;
		// 		const path = currentUrl.split("/v3/")[1];

		// 		if (path !== "users" && !path.includes("findme")) {
		// 			this.sendUrl(currentUrl.split("/v3/")[1]);
		// 		}
		// 	}
		// });
	},
};
</script>

<style>
@import "./assets/css/gstrackme-v3.css";
</style>
